import { ZAttrAccess } from "src/business/access/ZAttrAccess";
import { ZSpecAccess } from "src/business/access/ZSpecAccess";

// Потребовалось расширить имеющиеся типы ZAttrAccess и ZSpecAccess,
// чтобы включить информацию, которая используется в процессе редактирования.
// Для обратного преобразования достаточно использовать zSpecAccess.parse, чтобы отсечь лишие поля.

// Прямое измение данных имеет свои недостатки - будут вылазить ворнинги мобикса и линтер такого тоже не любит.
// Лучше было бы хранить эту инфу в каком-то словаре прямо в сторе,
// но сейчас нет нормального метода для получения уникального ключа.
// Есть возможность того, что один атрибут появится в составе разных спецификаций на каких-то разных уровнях вложенности.

export type EditableAttrAccess = Omit<ZAttrAccess, "attributes"> & {
  collapsed?: boolean;
  level: number;
  attributes?: EditableAttrAccess[];
};

export type EditableSpecAccess = Omit<ZSpecAccess, "attributes"> & {
  attributes: EditableAttrAccess[];
};

const attrAccessToEditable = (
  src: ZAttrAccess,
  level: number,
): EditableAttrAccess => ({
  ...src,
  collapsed: src.attributes ? false : undefined,
  attributes: src.attributes
    ? attrAccessListToEditable(src.attributes, level + 1)
    : undefined,
  level,
});

const attrAccessListToEditable = (
  src: ZAttrAccess[],
  level: number,
): EditableAttrAccess[] => src.map((it) => attrAccessToEditable(it, level));

const specAccessToEditable = (src: ZSpecAccess): EditableSpecAccess => ({
  ...src,
  attributes: attrAccessListToEditable(src.attributes, 0),
});

export const specAccessListToEditable = (
  src: ZSpecAccess[],
): EditableSpecAccess[] => src.map(specAccessToEditable);

export const getVisibleAttrs = (
  attrs: EditableAttrAccess[],
): EditableAttrAccess[] => {
  let res: EditableAttrAccess[] = [];
  attrs.forEach((it) => {
    res.push(it);
    if (it.attributes && !it.collapsed) {
      res = [...res, ...getVisibleAttrs(it.attributes)];
    }
  });
  return res;
};
